<template>
  <with-actions>
    <div class="form-inline ml-auto" slot="context-actions" v-if="can('write_customers')">
      <button class="btn btn-primary" @click="create">{{ 'create' | t }}</button>
    </div>
    <div class="card">
      <div class="card-body" v-if="customer">
        <div class="row">
          <div class="col-2"></div>
          <div class="col-8">
            <div class="form-group">
              <label>{{ 'description' | t }}</label>
              <input class="form-control" v-model="staff_access.description" />
            </div>
            <div class="form-group">
              <label>{{ 'hours_estimated' | t }}</label>
              <input class="form-control" v-model="staff_access.hours_estimated" />
            </div>
            <div class="form-group">
              <label>{{ 'price_per_hour' | t }}</label>
              <div class="input-group">
                <input class="form-control" v-model="staff_access.price_per_hour" />
                <div class="input-group-append">
                  <div class="input-group-text">{{ customer.currency }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </with-actions>
</template>
<script>
import Api from '@/store/jsonapi';
import _ from 'lodash';
import Alerts from '@/utils/alerts.js';

export default {
  props: ['customer_id'],
  data: function () {
    return {
      staff_access: {
        customer: { id: this.customer_id },
        plan_id: '',
        description: '',
        price_per_hour: '',
        hours_estimated: ''
      },
      customer: null,
      loading: false,
      plans: []
    };
  },
  watch: {},
  computed: {},
  methods: {
    async create() {
      //this.staff_access.purchase.quantity = this.staff_access.hours_estimated
      await Api.create('staff_accesses', this.staff_access)
        .then(() => {
          Alerts.success({
            title: 'Success',
            detail: 'Staff access requested'
          });
          this.$router.push({
            name: 'customers_show',
            params: { customer_id: this.customer_id }
          });
        })
        .catch(({ errors }) => {
          Alerts.danger({ title: errors[0].title, detail: errors[0].detail });
        });
    }
  },
  mounted: async function () {
    let { data: customer } = await Api.find('customers', this.customer_id);
    this.customer = customer;
    let { data: plans } = await Api.findAllPages('plans', {
      filter: { currency: customer.currency }
    });
    this.plans = plans;
    this.setBreadcrumbs([
      { to: { name: 'customers' }, text: 'Customers' },
      {
        to: { name: 'customers_show', customer_id: this.customer_id },
        text: this.customer.name
      },
      { to: {}, text: 'New staff access' }
    ]);
  }
};
</script>

<style scoped></style>
